import styled from 'styled-components';

const prefixWidth = '90px';

export const Row = styled.div`
  display: flex;
`;

export const Prefix = styled.div`
  width: ${prefixWidth};
  opacity: 0.6;
`;

export const Control = styled.div`
  width: calc(100% - ${prefixWidth});

  .display {
    position: relative;
    z-index: 15;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  z-index: 10;
  background: ${(p) => p.theme.darkTransparent};
  ${(p) => p.theme.opacityAnimationStyle}
  ${(p) => p.theme.fitContainerStyle}

  &.is-enter,
  &.is-exit-active {
    opacity: 0;
  }

  &.is-enter-active {
    opacity: 1;
  }
`;
